var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.containerClass }, [
    _c(
      "ul",
      _vm._l(_vm.posts, function(article, index) {
        return _c(
          "li",
          {
            staticClass: "post",
            on: {
              click: function($event) {
                return _vm.openPost("post_" + index, article.url, article)
              }
            }
          },
          [
            _c("a", [
              _c("div", { staticClass: "post" }, [
                _c("div", { staticClass: "imageWrap" }, [
                  article.thumbnail
                    ? _c("div", { staticClass: "imageInner" }, [
                        _c("img", {
                          attrs: {
                            src: article.thumbnail,
                            alt: article.post.post_title
                          }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "innerText" }, [
                  _c("h2", {
                    staticClass: "blogTitle",
                    domProps: { innerHTML: _vm._s(article.post.post_title) }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "blogDate",
                    domProps: { innerHTML: _vm._s(article.post_date) }
                  }),
                  _vm._v(" "),
                  article.excerpt
                    ? _c("div", {
                        staticClass: "blogExcerpt",
                        domProps: { innerHTML: _vm._s(article.excerpt) }
                      })
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }